<template>
  <div style="margin:5%;">
    <b-table striped hover :items="items"></b-table>
  </div>
</template>
<script>

import server from '../../api/server.vue'

const items = [
  { isActive: true, age: 40, first_name: 'Loading', last_name: 'Loading' },
]

export default {
  name: 'Scankanbanreference',
  data() {
    return {
        items: items
      };
  },
  methods: {
  },
  mounted: function () {
    // `this` est une référence à l'instance de vm
    if ( this.$route.params.action == 'last') {
      server.getLastScanKanbanReference('STEP_WS_10').then( response =>  {
        this.items = response.data
        //_cellVariants: { isActive: 'success', age: 'info', first_name: 'warning' }
      })
    }
    else {
      server.getAllScanKanbanReference('STEP_WS_10').then( response =>  {
        this.items = response.data
        //_cellVariants: { isActive: 'success', age: 'info', first_name: 'warning' }
      })

    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/andon/scans_reference.vue